import {generateThemes} from '@nfq/colors';

import type {GetThemeType} from '@nfq/colors';

export const BaseColors = {
    /** Focus color. ![#9787FF](https://dummyimage.com/12/9787FF/9787FF.png) `#9787FF`. */
    focus: '#9787FF',
    /** M-net cyan color. ![#008FD6](https://dummyimage.com/12/008FD6/008FD6.png) `#008FD6`. */
    mnet: '#008FD6',
    /** Pure white color. ![#FFFFFF](https://dummyimage.com/12/FFFFFF/FFFFFF.png) `#FFFFFF`. */
    neutral0: '#FFFFFF',
    /** Very light gray color. ![#FAFAFA](https://dummyimage.com/12/FAFAFA/FAFAFA.png) `#FAFAFA`. */
    neutral50: '#FAFAFA',
    /** Light gray color. ![#F5F5F5](https://dummyimage.com/12/F5F5F5/F5F5F5.png) `#F5F5F5`. */
    neutral100: '#F5F5F5',
    /** Light medium gray color. ![#E4E4E7](https://dummyimage.com/12/E4E4E7/E4E4E7.png) `#E4E4E7`. */
    neutral200: '#E4E4E7',
    /** Medium light gray color. ![#D4D4D8](https://dummyimage.com/12/D4D4D8/D4D4D8.png) `#D4D4D8`. */
    neutral300: '#D4D4D8',
    /** Medium gray color. ![#A1A1AA](https://dummyimage.com/12/A1A1AA/A1A1AA.png) `#A1A1AA`. */
    neutral400: '#A1A1AA',
    /** Medium dark gray color. ![#71717A](https://dummyimage.com/12/71717A/71717A.png) `#71717A`. */
    neutral500: '#71717A',
    /** Dark medium gray color. ![#52525B](https://dummyimage.com/12/52525B/52525B.png) `#52525B`. */
    neutral600: '#52525B',
    /** Dark gray color. ![#3F3F46](https://dummyimage.com/12/3F3F46/3F3F46.png) `#3F3F46`. */
    neutral700: '#3F3F46',
    /** Very dark gray color. ![#27272A](https://dummyimage.com/12/27272A/27272A.png) `#27272A`. */
    neutral800: '#27272A',
    /** Darker gray color. ![#18181B](https://dummyimage.com/12/18181B/18181B.png) `#18181B`. */
    neutral900: '#18181B',
    /** Pure black color. ![#000000](https://dummyimage.com/12/000000/000000.png) `#000000`. */
    neutral1000: '#000000',
    /** SWM blue color. ![#005297](https://dummyimage.com/12/005297/005297.png) `#005297`. */
    swmBlue: '#005297',
    /** SWM green color. ![#52AE32](https://dummyimage.com/12/52AE32/52AE32.png) `#52AE32`. */
    swmGreen: '#52AE32',
    /** Telekom magenta color. ![#E20074](https://dummyimage.com/12/E20074/E20074.png) `#E20074`. */
    telekom: '#E20074',
    /** Primary font color. ![#192630](https://dummyimage.com/12/192630/192630.png) `#192630`. */
    textPrimary: '#27272A',
    /** Primary font color on dark backgrounds. ![#FFFFFF](https://dummyimage.com/12/FFFFFF/FFFFFF.png) `#FFFFFF`. */
    textPrimaryInverted: '#FFFFFF',
    /** Secondary font color. ![#6B7280](https://dummyimage.com/12/6B7280/6B7280.png) `#6B7280`. */
    textSecondary: '#6E6E77',
    /** Secondary font color on dark backgrounds. ![#A1A1AA](https://dummyimage.com/12/A1A1AA/A1A1AA.png) `#A1A1AA`. */
    textSecondaryInverted: '#A1A1AA'
} as const;

export const DerivedColors = {} as const;

export const BoxShadows = {
    /** The default dropshadow for Popovers. */
    popOverShadow: '0px 0px 10px 5px rgba(25, 38, 48, 0.05)'
} as const;

// BaseColors, DerivedColors, BoxShadows, 'light', 'dark'

export type BaseColorsType = GetThemeType<typeof BaseColors>;
export const {
    globalCss,
    shadows,
    themeColors,
    themes
} = generateThemes({
    baseColors: BaseColors,
    derivedColors: DerivedColors,
    shadows: BoxShadows
});